import Api from "..";
import TransmedValidator, {
  TransmedValidatorInput,
  TransmedValidatorUpdateInput,
} from "../../dtos/transmed/process/validator";
import transform from "../../service/transform";

export default class TransmedValidatorApi extends Api {
  constructor() {
    super("transmed/validator");
  }

  public async get(): Promise<TransmedValidator[]> {
    const data = (await super.get()).data;
    if (!Array.isArray(data))
      throw new TypeError("TransmedValidator entry list is not an array.");

    return await Promise.all(
      data.map(async (value) => await transform(TransmedValidator)(value))
    );
  }

  public async post(data: TransmedValidatorInput): Promise<TransmedValidator> {
    return await transform(TransmedValidator)((await super.post(data)).data);
  }

  public async put(
    id: string,
    data: TransmedValidatorUpdateInput
  ): Promise<TransmedValidator> {
    return await transform(TransmedValidator)((await super.put(id, data)).data);
  }

  public async delete(id: string): Promise<void> {
    await super.delete(id);
  }
}
